import type { SVGProps } from 'react';
const DawnFlagHT = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-HT_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-HT_svg__a)">
      <path fill="#112EBC" fillRule="evenodd" d="M0 7.467h22V0H0z" clipRule="evenodd" />
      <path fill="#E3264A" fillRule="evenodd" d="M0 16h22V7.467H0z" clipRule="evenodd" />
      <rect
        width={7.333}
        height={6.4}
        x={7.333}
        y={5.333}
        fill="url(#dawn-flag-HT_svg__b)"
        rx={0.667}
      />
      <mask
        id="dawn-flag-HT_svg__c"
        width={8}
        height={7}
        x={7}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <rect width={7.333} height={6.4} x={7.333} y={5.333} fill="#fff" rx={0.667} />
      </mask>
      <g mask="url(#dawn-flag-HT_svg__c)">
        <path
          fill="#AABCAE"
          stroke="#366C14"
          strokeWidth={0.667}
          d="M7.666 11.4v-.53l1.343-.683c.328-.167.691-.254 1.059-.254h1.863c.368 0 .731.087 1.059.254l1.343.684v.529z"
        />
        <path
          fill="#D4B872"
          fillRule="evenodd"
          d="M11 9.6c.868 0 1.572-.716 1.572-1.6S11.868 6.4 11 6.4 9.43 7.116 9.43 8 10.132 9.6 11 9.6"
          clipRule="evenodd"
        />
        <path
          fill="#C28321"
          stroke="#0D3488"
          strokeWidth={0.667}
          d="m9.258 9.144 1.11.905a1 1 0 0 0 1.264 0l1.11-.905a.333.333 0 0 1 .544.259V10c0 .184-.15.333-.334.333H9.048A.333.333 0 0 1 8.714 10v-.597c0-.281.326-.436.544-.259Z"
        />
        <path
          fill="#216C30"
          fillRule="evenodd"
          d="M9.985 6.967a.333.333 0 0 1 .238-.567h1.554c.296 0 .445.356.238.567l-.777.79a.333.333 0 0 1-.476 0z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-HT_svg__b"
        x1={7.333}
        x2={7.333}
        y1={5.333}
        y2={11.733}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F0F0F0" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagHT;
